export default function () {
    return (
        <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M50 86.0677C69.9197 86.0677 86.0678 69.9196 86.0678 49.9999C86.0678 30.0802 69.9197 13.9321 50 13.9321C30.0804 13.9321 13.9323 30.0802 13.9323 49.9999C13.9323 69.9196 30.0804 86.0677 50 86.0677Z"
                fill="#3F68E0"
            />
            <path d="M30.4912 45.1438H59.3261" stroke="white" strokeWidth="3.6" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M27.2322 54.8562H56.0671" stroke="white" strokeWidth="3.6" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M66.5203 63.2484C63.4867 67.1192 58.9911 69.0256 54.3409 69.0256C44.506 69.0256 36.5325 60.5046 36.5325 49.9999C36.5325 39.4951 44.506 30.9741 54.3409 30.9741C60.2599 30.9741 64.9359 32.7453 67.9372 37.4534"
                stroke="white"
                strokeWidth="3.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
